import React, {useState, useEffect, useRef} from 'react';
import useMappedState from '@src/utils/useMappedState';
import './customer.m.css';
import history from '@src/utils/history';
import {
  hotsQuestions,
  getSuggestions,
  getResponse,
  createSession,
  getSession,
  sendMessage,
  getQueue,
  getEvent,
  dropCall,
  appraise,
  cancelQueue
} from './thunk.js'
import {
  Link,
  addLikeMessage,
  addSystemMessage,
  modifySystemMessage,
  addUserMessage,
  addActionCard,
  addLinkSnippet,
  addResponseMessage,
  setQuickButtons,
  toggleMsgLoader,
  Widget,
  addBannerData,
  setRateMessage,
  addFeedback,
  handleTextInputChange
} from '@cloud/customer-chat/lib';
import '@cloud/customer-chat/lib/styles.css'
import webConfig from "@src/configs/web.config";
import hwa from '@src/utils/hwa'

let timer = null;
let userTimer = null;
let icsId = ''
let SessionHeartbeatFlag = false;
let QueueHeartbeatFlag = false;
let ReturnSessionFlag = false;
let order = 0;
let number = 1;
let systemMessageId = 1;
export default (props) => {
  const loginStatus = props.loginStatus || null;
  const profileAvatar = require('./assets/profileAvatar.png')
  const [searchList, setsearchList] = useState([])
  const [hotPageSize, sethotPageSize] = useState(5)


  const getHotQuestions = async () => {
    let res = await hotsQuestions();
    if (res.data && res.data.questions) {
      let questions = res.data.questions;
      if (questions.map) {
        let hotData = questions.map(item => {
          return {
            title: item.st_question,
            onClick: () => {
              toggleMsgLoader();
              setTimeout(() => {
                getResponseInfo({
                  title: item.st_question
                })
              }, 1000)
            }
          }
        });
        let hotTotalPage = Math.ceil(hotData.length / hotPageSize);
        return {hotTotalPage, hotData};
      }
    }
    return {totalPage: 0, data: []};
  };

  // 获取常见问题
  const getHotContent = (data, pageNumber, pageSize) => {
    return data?.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
  };

  useEffect(() => {
    if (loginStatus === "true" && number == 1) {
      number = number + 1;
      addBannerData(require('./assets/bannerBg.png'),
        [{
          title: '问题反馈',
          action: (index) => {
            window.open(`#/wecode/feedback/feedbackedit`, "_blank")
          }
        }
        ]
      );
      getHotQuestions().then((res) => {
        let hotPageNumber = 0;
        let {hotTotalPage, hotData} = res;
        if (hotTotalPage !== 0) {
          let questions = getHotContent(hotData, hotPageNumber, hotPageSize);
          addLinkSnippet("常见问题", questions, () => {
            if (hotPageNumber === hotTotalPage - 1) {
              hotPageNumber = 0;
            } else {
              hotPageNumber = hotPageNumber + 1;
            }
            return getHotContent(hotData, hotPageNumber, hotPageSize);
          });
          hadSession();
        }
      });
      // 设置标签
      setQuickButtons([{label: '通讯录同步', value: '通讯录同步'}, {label: '认证对接', value: '认证对接'}, {
        label: '应用免登',
        value: '应用免登'
      }, {label: '消息对接', value: '消息对接'}, {label: '应用后台免登', value: '应用后台免登'}, {label: '数据回调', value: '数据回调'}]);
    }

  }, [loginStatus])

  // 获取回复消息
  const getResponseInfo = (params) => {
    getResponse({
      question: params.title,
      top: 5
    }).then(res => {
      if (res.data && res.data.answers && res.data.stQuestion) {
        addResponseMessage(res.data.answers);
        toggleMsgLoader();
      } else {
        addSystemMessage(`非常抱歉，这个问题我暂时答不来，你可以通过提交【问题反馈】来进一步沟通。`)
        noFeedback();
        toggleMsgLoader();
      }
    })
  }
  const handleSubmit = (msgText) => {
    getSession().then(res => {
      if (res.data && res.data.returnData && res.data.returnData.icsId) {
        let icsId = res.data.returnData.icsId
        sendMessage({
          msgContent: msgText,
          icsId: icsId
        }).then(res => {
          if (res.data && res.data.returnData == 200) {
          }
        })
      } else {
        toggleMsgLoader();
        setTimeout(() => {
          getResponseInfo({title: msgText})
        }, 1000)
      }
    })

    return true;
  }
  // 获取搜索列表
  const handleTextInputChange = (msgText) => {
    clearTimeout(timer)
    msgText && (timer = setTimeout(function () {
      getSuggestions({
        question: msgText,
        top: 5
      }).then(res => {
        let questions = [];
        res.data && res.data.questions && res.data.questions.map(item => {
          questions.push({value: item})
        });
        setsearchList(questions)
      })
    }, 500))
  }
  // 发送消息
  const handleNewUserMessage = (newMessage) => {
    handleSubmit(newMessage);
  }
  // 点击标签
  const handleQuickButtonClicked = (e) => {
    toggleMsgLoader();
    setTimeout(() => {
      getResponseInfo({title: e});
    }, 1000)
  }

  // 查看是否已建立会话
  const hadSession = () => {
    getSession().then(res => {
      if (res.data && res.data.returnData && res.data.returnData.icsId) {
        QueueHeartbeatFlag = false;
        SessionHeartbeatFlag = true;
        ReturnSessionFlag = true;
        SessionHeartbeat(res.data.returnData.icsId);
        addSystemMessage("客服继续为您服务")
        systemMessageId = res.data.returnData.icsId;
      }
    })
  }

  // 创建会话
  const getCreateSession = () => {
    if (icsId) {
      systemMessageId = icsId
      addSystemMessage("正在为您接通人工客服...", {
        operateText: '取消',
        operateFunc: (disableOperate) => {
          cancelQueue(icsId).then(res => {
            if (res.code === '200') {
              modifySystemMessage(systemMessageId, '排队已取消，期待您的下次咨询', {
                operateText: '',
                operateFunc: () => {
                },
                operateDisable: true
              })
            }
          });
          QueueHeartbeatFlag = false;
          SessionHeartbeatFlag = false;
          disableOperate(true);
        }
      }, systemMessageId);
    } else {
      addSystemMessage("正在为您接通人工客服...", {
        operateText: '取消',
        operateFunc: (disableOperate) => {
          modifySystemMessage(systemMessageId, '排队已取消，期待您的下次咨询', {
            operateText: '',
            operateFunc: () => {
            },
            operateDisable: true
          })
          QueueHeartbeatFlag = false;
          SessionHeartbeatFlag = false;
          disableOperate(true);
        }
      }, systemMessageId);
    }
    createSession().then(res => {
      if (res.code === '200' && res.data.returnDesc === 'return exist session id') {
        modifySystemMessage(systemMessageId, '客服继续为您服务', {})
      } else if (res.data && res.data.returnData && res.data.returnData.icsId) {
        SessionHeartbeatFlag = true;
        icsId = res.data.returnData.icsId;
        SessionHeartbeat(res.data.returnData.icsId);
      } else {
        modifySystemMessage(systemMessageId, '网络连接失败，请稍后重试', {
          operateText: '取消',
          operateFunc: () => {
          },
          operateDisable: true
        })
      }

    })
  }

  // 会话消息的递归：
  const SessionHeartbeat = (icsId) => {
    let timer = setInterval(() => {
      if (SessionHeartbeatFlag) {
        pollEvent(icsId);
      } else {
        clearInterval(timer);
      }
    }, 2000);
  }

  // 排队消息的递归：
  const QueueHeartbeat = (icsId) => {
    let timer = setInterval(() => {
      if (QueueHeartbeatFlag) {
        dealWithQueue(icsId);
      } else {
        clearInterval(timer);
      }
    }, 5000);
  }

  const pollEvent = (icsId) => {
    getEvent(icsId).then(res => {
      if (res && res.data.returnData && res.code === '200') {
        res.data.returnData.map(item => {
          switch (item.eventType) {
            // *********************************** 1.创建成功： ***********************************
            case 'WECC_WEBM_CALL_CONNECTED': {
              ReturnSessionFlag = false;
              // 递归标识修改：
              QueueHeartbeatFlag = false;
              modifySystemMessage(systemMessageId, "您好，我是您的专属客服，请问有什么可以帮您？", {
                operateText: '',
                operateFunc: () => {
                },
                operateDisable: true
              })
            }
              break
            //  *********************************** 1.排队： ***********************************
            case 'WECC_WEBM_CALL_QUEUING':
              ReturnSessionFlag = false;
              QueueHeartbeatFlag = true;
              QueueHeartbeat(icsId);
              break
            //  *********************************** 1.拉起会话失败 ***********************************
            case 'WECC_WEBM_CALL_FAIL': {
              ReturnSessionFlag = false;
              // 递归标识修改：
              SessionHeartbeatFlag = false;
              QueueHeartbeatFlag = false;
              modifySystemMessage(systemMessageId, "当前无客服在线", {});
            }
              break

            // *********************************** 2.排队超时： ***********************************
            case 'WECC_WEBM_QUEUE_TIMEOUT': {
              ReturnSessionFlag = false;
              // 递归标识修改：
              SessionHeartbeatFlag = false;
              QueueHeartbeatFlag = false;
              modifySystemMessage(systemMessageId, '当前客服繁忙，排队超时！请稍后重试', {});
            }
              break
            //  *********************************** 2.接收到坐席消息：
            case 'WECC_CHAT_RECEIVEDATA': {
              ReturnSessionFlag = false;

              if (item.content && item.content.msgType === '2') {
                // 坐席消息-只接受文字：
                // 封装提问模板
                // json.result --10：文件；20：接收成功；30：拒绝接受；40：图片
                addResponseMessage(item.content.chatContent)
              }
            }
              break
            //  *********************************** 3.会话挂断： ***********************************
            case 'WECC_WEBM_CALL_DISCONNECTED': {
              ReturnSessionFlag = false;
              addSystemMessage("人工客服已退出服务，感谢您的咨询")
              // 评分
              setRateMessage((rate) => {
                let score = 3;
                if (rate == 1) {
                  score = 3
                } else if (rate == 2) {
                  score = 2
                } else if (rate == 3) {
                  score = 1
                }
                appraise({
                  icsId: icsId,
                  score: score,
                  isSolved: 1,
                  attitude: 1
                }).then(res => {
                  addResponseMessage('感谢您的评价，有问题可再次联系我');
                })
              })
              // 递归标识修改：
              SessionHeartbeatFlag = false;
              QueueHeartbeatFlag = false;

            }
              break
            default:
              ReturnSessionFlag = false;
          }
        })
      }
    })
  }

  const dealWithQueue = async () => {
    let queueJson = await getQueue(icsId);
    if (queueJson.data && queueJson.data.returnData && queueJson.data.returnData.position) {
      order = queueJson.data.returnData.position;
      modifySystemMessage(systemMessageId, `当前客服繁忙，您排在第${order}位`)
    }
  }

  // 无回复的时候显示卡片
  const noFeedback = () => {
    addFeedback([{
      icon: require('./assets/feedback.png'),
      title: '问题反馈',
      action: (index) => {
        window.open(`#/wecode/feedback/feedbackedit`, "_blank")
      }
    }
    ])
  }


  // 点击组件弹框事件
  const widgetClicked = () => {
    hwa('welinkopen_contact', {
      card: '开放平台',
    })
    if (loginStatus === 'true') {
      return true
    } else {
      window.open('about:blank').location.href = webConfig.goLoginURl(window.location.href);
      return false
    }
  }

  return (
    <Widget
      title="智能客服"
      senderPlaceHolder="请输入您要咨询的问题"
      handleNewUserMessage={handleNewUserMessage}
      handleQuickButtonClicked={handleQuickButtonClicked}
      widgetClicked={widgetClicked}
      imagePreview={true}
      handleSubmit={handleSubmit}
      suggestions={searchList}
      handleTextInputChange={handleTextInputChange}
      profileAvatar={profileAvatar}
    />
  )

}
